module.exports = "div.full-height-minus-search {\n  height: calc(100% - 4.375rem);\n  position: relative; }\n\ndiv.sh-message {\n  padding-left: 15px;\n  margin-top: -5px;\n  padding-bottom: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/views/property-view.component.scss
// module id = ./src/app/main/views/property-view.component.scss
// module chunks = main